import { Question } from './question';

export class QuestionCode extends Question {
  resultat: string;
  technologie = '';
  codeComplet = '// entrez ici un exemple de manière de réussir l\'exercice';
  codePrerempli = '// le candidat va coder à partir de ce code prérempli';
}
